import React from 'react'
import { BrowserRouter, Route, Switch, withRouter } from 'react-router-dom'

import ApplicationScreenWrapper from './application/ApplicationScreenWrapper'
import LoadingScreen from './application/loading/LoadingScreen'
import { RouterContext } from './contexts'
import { withTracker } from './ga'

const CLOSED = true

const LazyEndedContainer = React.lazy(() =>
  import('./application/ended/EndedContainer'),
)

const LazyGreetingsContainer = React.lazy(() =>
  import('./application/greetings/GreetingsContainer'),
)

const LazyRegistrationContainer = React.lazy(() =>
  import('./application/registration/RegistrationContainer'),
)

const LazyPlayerContainer = React.lazy(() =>
  import('./application/player/PlayerContainer'),
)

const ApplicationRouterContextProvider = withRouter(
  ({ children, ...routerProps }) => (
    <RouterContext.Provider value={routerProps}>
      {children}
    </RouterContext.Provider>
  ),
)

const onRouterUpdate = () => {
  /* global document */
  const main = document.querySelector('main')
  if (main && typeof main.scrollTo === 'function') {
    main.scrollTo(0, 0)
  }
}

const ApplicationRouter = () => (
  <BrowserRouter onUpdate={onRouterUpdate}>
    <ApplicationRouterContextProvider>
      <React.Suspense fallback={<LoadingScreen />}>
        <ApplicationScreenWrapper>
          <Switch>
            <Route
              component={withTracker(LazyPlayerContainer)}
              path="/player/:id"
            />

            {!CLOSED && (
              <React.Fragment>
                <Route
                  path="/registration"
                  component={withTracker(LazyRegistrationContainer)}
                />

                <Route component={withTracker(LazyGreetingsContainer)} />
              </React.Fragment>
            )}

            {CLOSED && <Route component={withTracker(LazyEndedContainer)} />}
          </Switch>
        </ApplicationScreenWrapper>
      </React.Suspense>
    </ApplicationRouterContextProvider>
  </BrowserRouter>
)

export default ApplicationRouter
